import { ErrorHandler } from '@angular/core';
import { CommonExternalModule } from './common.external.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { AuthtokenInterceptor } from './interceptors/authtoken.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthGuard } from './guards/auth.guard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe, DecimalPipe } from '@angular/common';
import { GlobalErrorHandler } from './shared/globalChunk-errorHandler';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonExternalModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatNativeDateModule,
    NgxSpinnerModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    DatePipe,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthtokenInterceptor,
      multi: true,
    },
    DecimalPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
